import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    reportToolbarWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    datasetLayout: {
      width: '100%',
    },
    filtersLayout: {
      display: 'flex',
      width: '100%',
      gap: theme.spacing(1),
      padding: theme.spacing(1),
      flexWrap: 'wrap',
    },
    verticalDivider: {
      height: 'auto',
    },
  };
};
